import api from './api';
import type { VenueLocation } from '../types/venue';

const base = (venueId: string) => `/admin/venue/${venueId}/location`;

const venueLocationService = {
  /** Get all locations for a venue. TODO Phase 2. */
  getLocations: async (venueId: string): Promise<VenueLocation[]> => {
    const response = await api.get(base(venueId));
    return response.data;
  },

  /** Get a single location. TODO Phase 2. */
  getLocation: async (venueId: string, locationId: string): Promise<VenueLocation> => {
    const response = await api.get(`${base(venueId)}/${locationId}`);
    return response.data;
  },

  /** Create a location for a venue. TODO Phase 2. */
  createLocation: async (
    venueId: string,
    data: Omit<VenueLocation, '_id' | 'venueId' | 'createdAt' | 'updatedAt'>
  ): Promise<VenueLocation> => {
    const response = await api.post(base(venueId), data);
    return response.data;
  },

  /** Update a location. TODO Phase 2. */
  updateLocation: async (
    venueId: string,
    locationId: string,
    data: Partial<Omit<VenueLocation, '_id' | 'venueId' | 'createdAt' | 'updatedAt'>>
  ): Promise<VenueLocation> => {
    const response = await api.put(`${base(venueId)}/${locationId}`, data);
    return response.data;
  },

  /** Delete a location. TODO Phase 2. */
  deleteLocation: async (venueId: string, locationId: string): Promise<void> => {
    await api.delete(`${base(venueId)}/${locationId}`);
  },
};

export default venueLocationService;
